<template>
    <button :type="nativeType"
            :disabled="loading"
            :class="{
                [`btn-${type}`]: true,
                'btn-block': block,
                'btn-lg': large,
                'btn-sm': small,
                'btn-xsm': xsmall,
                'btn-loading': loading
            }"
            class="btn"
            @click="$emit('click')">
        <slot />
    </button>
</template>

<script>
export default {
    name: 'AppButton',
    props: {
        type: {
            type: String,
            default: 'primary'
        },
        nativeType: {
            type: String,
            default: 'submit'
        },
        loading: {
            type: Boolean,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        xsmall: {
            type: Boolean,
            default: false
        }
    }
};
</script>
